/* eslint-disable */

import moment from 'moment';
const sentinalToken = 'e5664dcd-4255-4d94-aa29-5a12862f2e38';

const WMSLayers = (function() {
  const layers = {
    ndvi: {
      name: 'NDVI',
      url: `https://services.sentinel-hub.com/ogc/wms/${sentinalToken}?showLogo=false&service=WMS&request=GetMap&styles=&version=1.1.1&maxcc=20`,
      layers: 'NDVI,DATE',
    },
    radarglobal: {
      type: 'tile',
      attribution: '<a href="https://www.aerisweather.com/">&copy;AerisWeather</a>',
      name: 'Radar',
      url: 'https://maps{s}.aerisapi.com/aJGWy42YueglFhOOQuVT1_g8M5ypIhaQZeLf5Z8m6aVmZfhA4j2jD0pQVoByDR/radar-global/{z}/{x}/{y}/current.png',
      subdomains: '1234',
      layers: '',
    },
    satellite: {
      type: 'tile',
      attribution: '<a href="https://www.aerisweather.com/">&copy;AerisWeather</a>',
      name: 'Satellite',
      url: 'https://maps{s}.aerisapi.com/aJGWy42YueglFhOOQuVT1_g8M5ypIhaQZeLf5Z8m6aVmZfhA4j2jD0pQVoByDR/satellite-infrared-color/{z}/{x}/{y}/current.png',
      subdomains: '1234',
      layers: '',
    },
    temperaturec: {
      type: 'tile',
      attribution: '<a href="https://www.aerisweather.com/">&copy;AerisWeather</a>',
      name: 'Temperature °C',
      url: 'https://maps{s}.aerisapi.com/aJGWy42YueglFhOOQuVT1_g8M5ypIhaQZeLf5Z8m6aVmZfhA4j2jD0pQVoByDR/temperatures,temperatures-text-metric/{z}/{x}/{y}/current.png',
      subdomains: '1234',
      layers: '',
    },
    temperaturef: {
      type: 'tile',
      attribution: '<a href="https://www.aerisweather.com/">&copy;AerisWeather</a>',
      name: 'Temperature °F',
      url: 'https://maps{s}.aerisapi.com/aJGWy42YueglFhOOQuVT1_g8M5ypIhaQZeLf5Z8m6aVmZfhA4j2jD0pQVoByDR/temperatures,temperatures-text/{z}/{x}/{y}/current.png',
      subdomains: '1234',
      layers: '',
    },
    precip: {
      type: 'tile',
      attribution: '<a href="https://www.aerisweather.com/">&copy;AerisWeather</a>',
      name: 'Precipitation',
      url: 'https://maps{s}.aerisapi.com/aJGWy42YueglFhOOQuVT1_g8M5ypIhaQZeLf5Z8m6aVmZfhA4j2jD0pQVoByDR/fqpf-accum/{z}/{x}/{y}/current.png',
      subdomains: '1234',
      layers: '',
    },
    humidity: {
      type: 'tile',
      attribution: '<a href="https://www.aerisweather.com/">&copy;AerisWeather</a>',
      name: 'Humidity',
      url: 'https://maps{s}.aerisapi.com/aJGWy42YueglFhOOQuVT1_g8M5ypIhaQZeLf5Z8m6aVmZfhA4j2jD0pQVoByDR/humidity,humidity-text/{z}/{x}/{y}/current.png',
      subdomains: '1234',
      layers: '',
    },
    clay: {
      name: 'Clay',
      url: 'https://maps.isric.org/mapserv?map=/map/clay.map',
      layers:  'clay_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/clay.map&service=WMS&request=GetLegendGraphic&layers=clay_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    sand: {
      name: 'Sand',
      url: 'https://maps.isric.org/mapserv?map=/map/sand.map',
      layers: 'sand_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/sand.map&service=WMS&request=GetLegendGraphic&layers=sand_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    sand: {
      name: 'Silt',
      url: 'https://maps.isric.org/mapserv?map=/map/silt.map',
      layers: 'silt_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/silt.map&service=WMS&request=GetLegendGraphic&layers=silt_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    nitrogen: {
      name: 'Nitrogen',
      url: 'https://maps.isric.org/mapserv?map=/map/nitrogen.map',
      layers: 'nitrogen_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/nitrogen.map&service=WMS&request=GetLegendGraphic&layers=nitrogen_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    ph: {
      name: 'Soil pH in H20',
      url: 'https://maps.isric.org/mapserv?map=/map/phh20.map',
      layers: 'phh20_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/phh20.map&service=WMS&request=GetLegendGraphic&layers=phh20_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    bdod: {
      name: 'Bulk Density',
      url: 'https://maps.isric.org/mapserv?map=/map/bdod.map',
      layers: 'bdod_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/bdod.map&service=WMS&request=GetLegendGraphic&layers=bdod_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    organic_carbon: {
      name: 'Soil Organic Carbon',
      url: 'https://maps.isric.org/mapserv?map=/map/soc.map',
      layers: 'soc_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/soc.map&service=WMS&request=GetLegendGraphic&layers=soc_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    organic_carbon_stock: {
      name: 'Soil Organic Carbon Stock',
      url: 'https://maps.isric.org/mapserv?map=/map/ocs.map',
      layers: 'ocs_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/ocs.map&service=WMS&request=GetLegendGraphic&layers=ocs_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    organic_carbon_densities: {
      name: 'Organic Carbon Densities',
      url: 'https://maps.isric.org/mapserv?map=/map/ocd.map',
      layers: 'ocd_0-5cm_mean',
      legend: 'https://maps.isric.org/mapserv?map=/map/ocd.map&service=WMS&request=GetLegendGraphic&layers=ocd_0-5cm_mean&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857&maxZoom=20&bbox=-13562986.298921674,4688953.0631258525,-13561763.306469113,4690176.055578415',
    },
    disease: {
      name: 'Disease',
      url: `https://services.sentinel-hub.com/ogc/wms/${sentinalToken}?showLogo=false&service=WMS&request=GetMap&styles=&version=1.1.1&maxcc=20`,
      layers: 'NDVI,DATE',
      grades: [
        {
          "color": "#95ff4e",
          "value": "Very Healthy"
        },
        {
          "color": "#006666",
          "value": "Healthy"
        },
        {
          "color": "#32FFFF",
          "value": "Moderate Health"
        },
        {
          "color": "#ffff4e",
          "value": "Disease Onset"
        },
        {
          "color": "#830306",
          "value": "Diseased or no vegetation"
        },
      ],
    },
    evi: {
      name: 'Enhanced Vegetation Index',
      url: `https://services.sentinel-hub.com/ogc/wms/${sentinalToken}?showLogo=false&service=WMS&request=GetMap&styles=&version=1.1.1&maxcc=20`,
      layers: 'EVI,DATE',
    },
    moisture: {
      name: 'Moisture',
      url: `https://services.sentinel-hub.com/ogc/wms/${sentinalToken}?showLogo=false&service=WMS&request=GetMap&styles=&version=1.1.1&maxcc=20`,
      layers: 'MOISTURE_INDEX,DATE',
    },
    swir: {
      name: 'SWIR',
      url: `https://services.sentinel-hub.com/ogc/wms/${sentinalToken}?showLogo=false&service=WMS&request=GetMap&styles=&version=1.1.1&maxcc=20`,
      layers: 'SWIR,DATE',
    },
    agband: {
      name: 'Agriculture',
      url: `https://services.sentinel-hub.com/ogc/wms/${sentinalToken}?showLogo=false&service=WMS&request=GetMap&styles=&version=1.1.1&maxcc=20&`,
      layers: 'AGRICULTURE,DATE',
    },
    sentinel_2: {
      name: 'Sentinel-2',
      url: `https://services.sentinel-hub.com/ogc/wms/${sentinalToken}?showLogo=false&service=WMS&request=GetMap&styles=&version=1.1.1&maxcc=20`,
      layers: 'TRUE_COLOR,DATE',
    }
  };

  return {
    layers,
  };
})();
/* eslint-enable */
export default WMSLayers;

// http://85.214.241.121:8080/geoserver/wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&CRS=EPSG%3A900913&WIDTH=256&HEIGHT=256&TILED=true&service=WMS&request=GetMap&layers=undefined&styles=&format=image%2Fjpeg&transparent=false&version=1.1.1&leaflet=%5Bobject%20Object%5D&width=256&height=256&srs=EPSG%3A3857&bbox=-8416328.310424188,4875765.160254827,-8416022.562311048,4876070.908367964
// http://85.214.241.121:8080/geoserver/wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=SNDPPT_M_sl3_250m&CRS=EPSG%3A900913&WIDTH=256&HEIGHT=256&TILED=true&STYLES=
